// под атрибутами имеется ввиду реклама, автор, дата, обложка
export const PAGES_WITH_NO_ARTICLE_ATTRIBUTES = [
  '/reklama/amp/',
  '/team/amp/',
  '/about/amp/',
  '/health/o-proekte/amp/',
  '/health/eksperty/amp/',
];
